"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sushiCelo = void 0;
exports.sushiCelo = {
    minichefv1: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    minichef: '0x8084936982D089130e001b470eDf58faCA445008',
    router: '0x1421bDe4B10e8dd459b3BCb598810B1337D56842',
    complexRewarderTime: '0x1be211D8DA40BC0ae8719c6663307Bfc987b1d6c',
    complexRewarderTimerv2: '0xFa3de59eDd2500BA725Dad355B98E6a4346Ada7d',
};
